import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useLeadChallenge() {
  const [c, setC] = useState({ token: "", question: "" }); const [answer, setAnswer] = useState(""); const [website, setWebsite] = useState("");
  const reload = useCallback(() => { setAnswer(""); axios.get(`${API}/public/lead-challenge`).then(r => setC(r.data)).catch(() => setC({ token: "", question: "" })); }, []);
  useEffect(() => { reload(); }, [reload]);
  return { fields: { challenge_token: c.token, challenge_answer: answer, website }, question: c.question, answer, setAnswer, website, setWebsite, reload };
}

export function RobotCheck({ ch, className = "" }) {
  return <>
    <label className={className} data-testid="robot-check">Main robot nahi hoon: <b data-testid="robot-question">{ch.question || "…"}</b>
      <input inputMode="numeric" required value={ch.answer} onChange={e => ch.setAnswer(e.target.value.replace(/\D/g, "").slice(0, 3))} placeholder="Jawab likhein" data-testid="robot-answer-input" /></label>
    <input type="text" name="website" tabIndex={-1} autoComplete="off" aria-hidden="true" value={ch.website} onChange={e => ch.setWebsite(e.target.value)}
      style={{ position: "absolute", left: "-9999px", width: 1, height: 1, opacity: 0 }} data-testid="robot-honeypot" />
  </>;
}
